import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'crown', 'Crown', [["path",{"d":"M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4l4 -6","key":"svg-0"}]]);